import React, { useContext, useState } from "react";
import { Button, Modal } from "antd";

import paperShredder from "../../assets/images/webToLead/paper-shredder.svg";
import deleteIcon from "../../assets/images/webToLead/delete.svg";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";

const DeleteCustomField = ({
  isFormDelete,
  fieldName,
  onDelete,
  isExpired,
  onSubscription,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isWebToLeadDelete } = useContext(AuthContext);
  const { showAlert } = useAlert();

  const showModal = () => {
    if (isExpired && isFormDelete) {
      onSubscription();
    } else {
      if (isWebToLeadDelete) {
        setIsModalOpen(true);
      } else {
        showAlert(
          "warning",
          "Permission Denied",
          "You do not have permission to delete web to lead form."
        );
      }
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div
        className="heading14px d-flex align-items-center"
        style={{
          gap: 8,
          color: "#29292B",
          paddingLeft: 3,
          paddingRight: isFormDelete ? 40 : 0,
        }}
        onClick={showModal}
      >
        <img
          src={deleteIcon}
          alt=""
          width={16}
          height={13}
          className="cursor-pointer"
          style={{ marginBottom: 2 }}
        />
        {isFormDelete && "Delete"}
      </div>
      <Modal
        title={
          <div
            className="heading24px text-color-1C1C1C roboto-medium"
            style={{ padding: "20px 24px 10px" }}
          >
            Delete {isFormDelete ? fieldName : "Custom Field"}
          </div>
        }
        className="delete-popup"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <div
          style={{ padding: "0 24px 20px 24px" }}
          className="web-to-lead mt10"
        >
          <div
            className="d-flex align-items-center"
            style={{ gap: 50, margin: "0 24px 20px 24px" }}
          >
            <img src={paperShredder} alt="" />
            <div className="text-color-434040 heading16px mt10">
              {isFormDelete ? (
                <>
                  <div>Deleting this link will also delete the form.</div>
                  <div>Are you sure you want to continue?</div>
                </>
              ) : (
                <div>
                  Are you sure you want to delete this {fieldName} Field?
                </div>
              )}
              <div className="mt10">This action can’t be undone.</div>
            </div>
          </div>
          <div
            className="mt40 d-flex justify-content-end align-items-center"
            style={{ gap: 20 }}
          >
            <Button className="secondary-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              className="theme-btn"
              onClick={() => {
                onDelete();
                handleCancel();
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteCustomField;
